import {
  GET_ALLOCATORS_INIT,
  GET_ALLOCATORS_SUCCESS,
  GET_ALLOCATORS_FAILED,
  CREATE_INMAILS_INIT,
  CREATE_INMAILS_SUCCESS,
  CREATE_INMAILS_FAILED,
  ALLOCATORS_COUNT_INIT,
  ALLOCATORS_COUNT_SUCCESS,
  ALLOCATORS_COUNT_FAILED,
} from "./constant";

const initialState = {
  allocators: [],
  allocatorsCount: 0,
};
export default function inMailData(state = initialState, action) {
  switch (action.type) {
    case CREATE_INMAILS_INIT:
      return { ...state, loading: true };
    case CREATE_INMAILS_SUCCESS:
      return { ...state, loading: false };
    case CREATE_INMAILS_FAILED:
      return { ...state, loading: false };
    case ALLOCATORS_COUNT_INIT:
      return { ...state, loading: true };

    case ALLOCATORS_COUNT_SUCCESS:
      return { ...state, allocatorsCount: action.payload };

    case ALLOCATORS_COUNT_FAILED:
      return { ...state, loading: false };

    case GET_ALLOCATORS_INIT:
      return { ...state, loading: true };

    case GET_ALLOCATORS_SUCCESS:
      return { ...state, allocators: action.payload };

    case GET_ALLOCATORS_FAILED:
      return { ...state, loading: false };
    default:
      return { ...state };
  }
}
